import ENV from "./env";
import { RequestBody } from "./gcp.types";

const { BACKEND_URL } = ENV;

const fetchWithTimeout = async (
    url: string,
    options: RequestInit = {},
    timeout = 5000
): Promise<Response> => {
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);

    try {
        const response = await fetch(url, {
            ...options,
            signal: controller.signal,
        });
        clearTimeout(id);
        return response;
    } catch (error: any) {
        if (error.name === 'AbortError') {
            throw new Error('Request timed out');
        }
        throw error;
    }
};

const request = async (url: string, method: 'GET' | 'POST', body?: RequestBody) => {
    const headers: Record<string, string> = {};
    const getMethod = method === 'GET';

    const response = await fetchWithTimeout(url, {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined,
    });

    const convertedResponse = getMethod ? await response.text() : await response.json();

    if (!response.ok) {
        const error = await response.text();
        throw new Error(`Request failed: ${error}`);
    }

    return convertedResponse;
};

const getObjectCommand = async (Bucket: string, Key: string) => {
    const url = `${BACKEND_URL}/getFileFromStorage?bucketName=${encodeURIComponent(Bucket)}&filePath=${encodeURIComponent(Key)}`;
    try {
        const content = await request(url, 'GET');
        return content;
    } catch (error) {
        console.error('Error retrieving file: ', error);
        return null;
    }
};

export default getObjectCommand;